import WidgetModel from '../widget-model'
import ReportWidgetView from './report-widget-view'
import _ from 'lodash'
import Report from 'scoreboard/reports/report'

var ReportWidget = WidgetModel.extend({
	containerDefaults: {
		width: 480,
		height: 330
	},

	viewCls: ReportWidgetView,

	multiSettableProps: [ 'background', 'showHeaders', 'fontSize', 'tablePadding' ],

	section: _.constant('reports'),

	initialize: function (attr, opt = {}) {
		WidgetModel.prototype.initialize.apply(this, arguments)

		this.initializeReportModel(opt)

		this.listenTo(this.properties, 'change:label', function () {
			this.report.set('label', this.properties.get('label') || '')
		}.bind(this))
	},

	/**
	 * Sets up the Report model stored in this.report, taking into account the
	 * variety of ways it might be provided.
	 *
	 * @param opt options from canvas's wobs collection
	 */
	initializeReportModel: function (opt) {
		if (this.properties.get('reportId')) {
			// report widget was just added; use the report ID for now
			this.report = new Report({id: this.properties.get('reportId')})
		} else if (_.get(this.attributes, 'report')) {
			// Used when a deleted report widget is restored via the undo button
			this.report = new Report(this.attributes.report).toSubtype()
		} else if (this.get('wob')?.report) {
			// Widgets that haven't been saved yet but have been loaded from
			// a server data fetch (like in forms) will have the report in the
			// wob attributes
			// #58501 Forms will also have the report here if they have been
			// changed but the changes haven't been saved yet
			this.report = new Report(this.get('wob')?.report).toSubtype()
		} else if (this.properties.get('reportSubtype') && this.properties.get('reportSubtypeId')) {
			// report widget already existed; use the metadata
			var meta = this.data.reportMetadata(
				this.properties.get('reportSubtype'), this.properties.get('reportSubtypeId'))

			if (meta) {
				if (meta.organizationId == null) {
					// #23072 added a restriction that reports should only show results in
					// the same project, so the report request needs to include organizationId.
					//
					// report.js tries to use `reports.organizationnodeid`, but report widgets
					// don't have a `reports` table entry.
					//
					// It also tries to use `globals.orgId`, but if the user loads the page in
					// the bookmarks section, that won't have a value.
					//
					// Instead, use the dashboard's `organizationId`
					meta.organizationId = opt.organizationId
				}

				this.report = new Report(meta).toSubtype()
			}
		} else if (opt.report) {
			// Detect if model object has already been created, and
			// we just need to assign it
			if (opt.report.cid) {
				this.report = opt.report
			} else {
				// report metadata was passed in directly; just use that
				this.report = new Report(opt.report).toSubtype()
			}
		}

		if (this.report) {
			this.report.set('label', this.properties.get('label') || '')

			this.set('report', this.report.attributes)
			if (this.report.get('id')) {
				this.properties.set('reportId', this.report.get('id'))
			}
		}
	}
})

export default ReportWidget

ReportWidget.__filename__ = 'dashboards/widgets/report/report-widget-model.js'
